module.exports = __webpack_public_path__ + "img/WF-Logo.07da34fc.png";